import React, { useState } from 'react';
import { ExclamationTriangleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Modal } from '../../common';

/**
 * Delete account confirmation modal
 */
const DeleteAccountModal = ({ isOpen, onClose, onConfirm }) => {
  const [confirmation, setConfirmation] = useState('');

  const handleConfirm = () => {
    if (confirmation === 'DELETE') {
      onConfirm();
    }
  };

  const handleClose = () => {
    setConfirmation('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={<span className="text-red-600">Delete Account</span>}
      footer={
        <>
          <button
            type="button"
            onClick={handleClose}
            className="btn-secondary mr-4"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={confirmation !== 'DELETE'}
            className="delete-account-button"
          >
            <TrashIcon className="h-4 w-4 mr-2 inline" />
            Delete Account
          </button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <ExclamationTriangleIcon className="h-6 w-6 text-red-500 mt-0.5 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-red-800">Are you absolutely sure?</h4>
            <p className="text-sm text-red-700 mt-1">
              This action cannot be undone. This will permanently delete your account, 
              all your bookings, and remove you from any waitlists.
            </p>
          </div>
        </div>
        
        <div>
          <label className="form-label-small text-secondary">
            Please type <span className="font-mono font-bold">DELETE</span> to confirm:
          </label>
          <input
            type="text"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            className="form-input mt-1 block w-full px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
            placeholder="Type DELETE to confirm"
            autoComplete="off"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAccountModal;
